import Modal from "components/blocks/Modal";
import { useTranslation } from "react-i18next";

const translations = {
  en: {
    modalTitle: "User Type",
    modelMetaData: {
      title: "If you don't have an account, please create a new one ",
      description:
          "If you do not already have an account or are not affiliated with Imam Mohammad Ibn Saud Islamic University (students, employees, or faculty members), please create a new account ",
    },
    specialist: [
      {
        title: "Postgraduate Students",
        description: "Students enrolled in master's or doctoral programs who wish to submit a publication request.",
      },
      {
        title: "Specialist",
        description:
            "Any person not affiliated with Imam Mohammad Ibn Saud Islamic University who wishes to register on the funding or publishing platform, either to submit a publication request or to collaborate with the university in reviewing and evaluating research and requests. Once registered, the person is treated as an author/reviewer/evaluator based on the requests they submit or are assigned.",
      }
    ],
  },
  ar: {
    modalTitle: "نوع المستخدم",
    modelMetaData: {
      title: "إذا لم يكن لديك حساب ، يرجى إنشاء حساب جديد ",
      description:
          "إذا لم يكن لديك حساب مسبق أو  لست من منسوبي جامعة الإمام محمد بن سعود الإسلامية (طلاب و موظفين و أعضاء هيئة تدريس) ، يرجى إنشاء حساب جديد ",    },
    specialist: [
      {
        title: "طلاب دراسات عليا",
        description: "الطلاب الذين يدرسون في برامج الماجستير أو الدكتوراه و الذين يرغبون في التقديم على طلب نشر ",
      },
      {
        title: "متخصصا",
        description: "هو كل شخص ليس من منسوبي جامعة الإمام محمد بن سعود الإسلامية يرغب في التسجيل في منصة التمويل أو منصة النشر، إما لتقديم طلب نشر أو العمل مع الجامعة لفحص و تحكيم الابحاث و الطلبات و يعامل الشخص بعد التسجيل كمؤلف / فاحص / محكم حسب الطلبات التي يقدمها أو تسند له ",
      }
      ],
  }
};

const UserTypeGuideModal = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
  const {
    i18n: { language },
  } = useTranslation("RegisterView");
  const t = translations[language as "en" | "ar"];

  return (
    <Modal
      bodyMargin="my-2"
      title={t.modalTitle}
      isOpen={isOpen}
      onClose={onClose}
      withHeaderBorder
      containerClassName="bg-white"
      size="lg"
    >
      <div className="user-type-guide-modal-title">
        <h5 className="fw-bold mb-0">{t.modelMetaData.title}</h5>
      </div>
      <p>{t.modelMetaData.description}</p>

      <div className="divider" />

      <ul className="list-unstyled mt-3 p-0 overflow-auto">
        {t.specialist.map((type, index) => (
          <li key={index} className="mb-3">
            <p className="fw-bold mb-1">• {type.title}</p>
            <p className="text-muted me-2">{type.description}</p>
          </li>
        ))}
      </ul>
    </Modal>
  );
};

export default UserTypeGuideModal;
